module.exports = __webpack_public_path__ + "static/Cases1-f2f9ce6c4b6c7187324308d1033f340e.svg";